module.exports = __webpack_public_path__ + "img/fracpack-banner-home-bg.80e29668.webp";